import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Award,
  Download,
  Gift,
  PackageCheck,
  ReceiptText,
  Sparkles,
} from "lucide-react";
import { formatGiftCurrency } from "../stuffAdapters";
import "./GiftsPage.css";

const GiftDetails = () => {
  const navigate = useNavigate();

  return (
    <section className="gifts-page">
      <section className="gifts-mobile-detail-view">
        <header className="gifts-mobile-detail-header">
          <button
            type="button"
            onClick={() => navigate("/Gifts")}
            aria-label="Back to gifts"
          >
            <ArrowLeft size={19} strokeWidth={2.2} />
          </button>
          <div>
            <span>MY REWARDS</span>
            <h1>Gift Details</h1>
          </div>
          <span className="gifts-mobile-detail-header-icon">
            <Gift size={20} strokeWidth={2} />
          </span>
        </header>

        <div className="gifts-mobile-detail-stack">
          <section className="gifts-mobile-detail-card">
            <div className="gifts-mobile-detail-section-title">
              <span>
                <ReceiptText size={17} strokeWidth={2} />
              </span>
              <h2>Order Information</h2>
            </div>
            <div className="gifts-mobile-detail-grid">
              <div>
                <span>Order Date</span>
                <strong>01-08-2025 (12:13 pm IST)</strong>
              </div>
              <div>
                <span>Order ID</span>
                <strong>SA-220325-517501-CA61</strong>
              </div>
              <div>
                <span>Date</span>
                <strong>01-08-2025 (12:13 pm IST)</strong>
              </div>
              <div>
                <span>Level</span>
                <strong>Level - 1</strong>
              </div>
            </div>
          </section>

          <section className="gifts-mobile-detail-card">
            <div className="gifts-mobile-detail-section-title">
              <span>
                <PackageCheck size={17} strokeWidth={2} />
              </span>
              <h2>Product Information</h2>
            </div>
            <div className="gifts-mobile-product-card">
              <div className="gifts-mobile-detail-product-image">
                <img
                  src="../../assets/img/mobiles/mobiles-4.png"
                  alt="Salar Shopping Voucher"
                />
              </div>
              <div>
                <span>PRODUCT NAME</span>
                <h3>Salar Shopping Voucher</h3>
                <p>
                  <strong>Order Type:</strong> Original
                </p>
                <p>
                  <strong>Gen Code:</strong> S34O251
                </p>
              </div>
            </div>
          </section>

          <section className="gifts-mobile-detail-card">
            <div className="gifts-mobile-detail-section-title">
              <span>
                <Award size={17} strokeWidth={2} />
              </span>
              <h2>Achievement Reward</h2>
            </div>
            <div className="gifts-mobile-reward-list">
              <div>
                <span>1st Month Referral Incentive</span>
                <strong>{formatGiftCurrency(500)}</strong>
              </div>
              <div>
                <span>2nd Month Referral Incentive</span>
                <strong>{formatGiftCurrency(500)}</strong>
              </div>
              <div>
                <span>Salar Gift Credits</span>
                <strong>{formatGiftCurrency(500)}</strong>
              </div>
              <div>
                <span>Validity</span>
                <strong>1 Year</strong>
              </div>
              <div>
                <span>Status</span>
                <strong>
                  <span className="gifts-status gifts-status-pending">
                    Pending
                  </span>
                </strong>
              </div>
              <div>
                <span>Salar Remaining Credits</span>
                <strong>{formatGiftCurrency(500)}</strong>
              </div>
              <div>
                <span>Remaining Time</span>
                <strong>48 hrs. 12:00:00</strong>
              </div>
            </div>
          </section>

          <section className="gifts-mobile-detail-card">
            <div className="gifts-mobile-detail-section-title">
              <span>
                <Sparkles size={17} strokeWidth={2} />
              </span>
              <h2>Monthly Ref.Comm</h2>
            </div>
            <div className="gifts-mobile-reward-list">
              <div>
                <span>1st Month Referral Incentive</span>
                <strong>{formatGiftCurrency(500)}</strong>
              </div>
              <div>
                <span>2nd Month Referral Incentive</span>
                <strong>{formatGiftCurrency(500)}</strong>
              </div>
              <div>
                <span>Date</span>
                <strong>01-08-2025 (12:13 pm IST)</strong>
              </div>
              <div>
                <span>Status</span>
                <strong>
                  <span className="gifts-status gifts-status-pending">
                    Pending
                  </span>
                </strong>
              </div>
            </div>
          </section>

          <button type="button" className="gifts-mobile-download">
            <Download size={18} strokeWidth={2} />
            Download Payout Receipt
          </button>
        </div>
      </section>
    </section>
  );
};

export default GiftDetails;
